<template>
  <div>
    <ul class="tabs__header">
      <li
        v-for="(tab, index) in tabs"
        :key="tab.title"
        @click="selectTab(index)"
        :class="{
          tab__selected: index === selectedIndex,
          'full-width': fullWidth,
        }"
        style="font-size: 14px"
      >
        {{ tab.title }}
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedIndex: 0, // The index of the selected tab all of the tabs
      tabs: [],
    }
  },
  created() {
    this.tabs = this.$children
  },
  mounted() {
    this.selectTab(0)
  },
  methods: {
    selectTab(i) {
      this.$emit('selectedTab', i)
      this.selectedIndex = i

      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i
      })
    },
  },
}
</script>

<style scoped>
.tabs__header {
  list-style: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  border-bottom: 1px solid #eee;
}
.tabs__header li {
  text-align: center;
  padding: 8px 15px;
}
.tabs__header li.tab__selected {
  color: #2196f3;
  border-bottom: 2px solid #2196f3;
}
.tabs__header li.tab__selected:hover {
  background-color: #2196f320;
}
.tabs__header li:hover {
  background-color: #eee;
}
.tabs__header li:active {
  background-color: #2196f320;
}
.full-width {
  width: 100%;
  padding: 8px 0 !important;
}
</style>
